import { render, staticRenderFns } from "./ProjectLineItems.vue?vue&type=template&id=55e731b5&"
import script from "./ProjectLineItems.vue?vue&type=script&lang=js&"
export * from "./ProjectLineItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports